module.exports = __webpack_public_path__ + "static/media/check.1d28e169.svg";